import { useIsFetching } from '@tanstack/react-query';

export function GlobalLoadingBar() {
  const fetchCount = useIsFetching();
  if (!fetchCount) return null;
  return (
    <div
      role="progressbar"
      aria-label="Loading"
      aria-busy="true"
      className="fixed inset-x-0 top-0 z-50 h-1 animate-pulse bg-black"
    />
  );
}
